import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SchoolState {
  schoolId: string;
  uses_island_assignment_structure: boolean;
  enable_assignment_scoring: boolean;
  mentors_can_publish_assignments: boolean;
}

const initialState: SchoolState = {
  schoolId: "",
  uses_island_assignment_structure: false,
  enable_assignment_scoring: false,
  mentors_can_publish_assignments: false,
};

const schoolSlice = createSlice({
  name: "school",
  initialState,
  reducers: {
    setSchoolId: (state, action: PayloadAction<string>) => {
      state.schoolId = action.payload;
    },
    setUsesIslandAssignmentStructure: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.uses_island_assignment_structure = action.payload;
    },
    setEnableAssignmentScoring: (state, action: PayloadAction<boolean>) => {
      state.enable_assignment_scoring = action.payload;
    },
    setMentorsCanPublishAssignments: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.mentors_can_publish_assignments = action.payload;
    },
  },
});

export const {
  setSchoolId,
  setUsesIslandAssignmentStructure,
  setEnableAssignmentScoring,
  setMentorsCanPublishAssignments,
} = schoolSlice.actions;
export default schoolSlice.reducer;
